const StompJs = require("@stomp/stompjs");
import { useMainStore } from "@/store/index";
import { useToast } from "vue-toastification";

let store: any = {}
let toast: any = {}
class PriceFeed {
	private constructor(topic) {
		this.topic = topic
		// this.url = url
		store = useMainStore()
		toast = useToast()
		this.start()
	}
	private static _instance: PriceFeed;
	public socket: any
	private topic: any
	// private url: any
	private config: any
	public messagesData: any

	public static getInstance(topic?): PriceFeed {
		return this._instance || (this._instance = new this(topic));
	}

	public start() {
		this.socket = new StompJs.Client({
			brokerURL: `${process.env.VUE_APP_MARKET_URL}?access_token=${store.user.access_token}`,
			connectHeaders: {},
			debug: function () {
				//console.log('STOMP: ' + str);
			},
			forceBinaryWSFrames: true,
			appendMissingNULLonIncoming: true,
			reconnectDelay: 200,
			heartbeatIncoming: 4000,
			heartbeatOutgoing: 4000,
			onConnect: (e) => {
				this.subscribeMessages();
			},
			onStompError: (frame) => {
				console.log("Broker reported error: " + frame.headers["message"]);
				console.log("Additional details: " + frame.body);
			},
		});
		//this.socket.activate();
	}
	public subscribeMessages = () => {
		this.messagesData = this.socket.subscribe('/user/topic/follower/linking', (message) => {
			if (Object.keys(JSON.parse(message.body)).length) {
				const data = JSON.parse(message.body);
				if(data.success){
					store.accountConnectSocket = data
					toast.success('Your Trading Account has been connected successfully');
					store.$patch({'acoountconnecting' : false})
					store.$patch({'linkBrokerStatus' : true})
					try {
						(window as any).gtag('event', 'Live_ac_verified');
						(window as any).fbq('trackCustom', 'Live_ac_verified', {'email' : store.userAccoutDetail?.email,'value' : '50','country' : store.flavorData?.userCountry?.name }, {'eventID' : `${store.userAccoutDetail?.id}_Live_ac_verified`});
					} catch (ex) { console.log(ex); }
					const form = {
						'grant_type': 'refresh_token',
						'refresh_token': store.user.refresh_token
					};
					store.refreshToken(form, false, 'basic').then((response) => {
						if (response.access_token) {
							store.getUserAccountsList({}, false)
						}
					})
					// Gift card popup
					/*if(Object.keys(store.brokersList).length && store.brokersList.brokers?.length && store.linkBrokerID){
						const isAccount = store.brokersList.brokers.find(val=> val.id == store.linkBrokerID)
						if(isAccount?.integrationMode == 'INTEGRATED' || isAccount.integrationMode == 'CO_BRANDED') {
							store.$patch({'isGiftPopup' : true})
						} 
					}
					if(store.brokerPlatformList.length && store.linkBrokerID){
						store.brokerPlatformList.forEach((i) => {
							if (i.brokers && i.brokers.length) {
								const data = i.brokers.filter((i) => parseInt(i.id) == parseInt(store.linkBrokerID));
								if (data.length) {
									if(data[0]?.integrationMode == 'INTEGRATED' || data[0].integrationMode == 'CO_BRANDED') {
										store.$patch({'isGiftPopup' : true})
									} 
								}
							}
						});
					}*/
				}else{
					store.$patch({'socketError' : data})
					toast.success('Could not connect your Trading Account');
					store.$patch({'acoountconnecting' : false})
					store.$patch({'linkBrokerStatus' : false})
				}
			}
		});
	}
	public unsubscribe = () => {
		this.messagesData.unsubscribe();
		this.subscribeMessages();
	}
	public activate = () => {
		if (!this.socket.connected) {
			this.socket.activate();
		}
	}
	public deactivate = () => {
		this.socket.deactivate();
	}
}

export default PriceFeed
